import React, { useEffect } from "react"
import { Col, Row } from "reactstrap"
import {
  change,
  Field,
  formValueSelector,
  getFormSyncErrors,
  resetSection,
} from "redux-form"
import { SingleSelectField } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { copyList, getExperiences, getExperiencesList } from "store/actions"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
const CopyListModal = ({
  closeHandler,
  getExperiences,
  experiences,
  experiencesList,
  resetSection,
  getExperiencesList,
  change,
  formSyncErrors,
  copyList,
  listFeature,
  list,
  isListItem,
  backButtonHandler,
}) => {
  useEffect(() => {
    getExperiences()
    return () => {
      resetSection(FORM_NAMES.LIST, "list_form.experience")
      resetSection(FORM_NAMES.LIST, "list_form.list")
    }
  }, [])

  const copyListHandler = () => {
    if (
      !(
        formSyncErrors.hasOwnProperty("list_form") &&
        (formSyncErrors.list_form.hasOwnProperty("experience") ||
          formSyncErrors.list_form.hasOwnProperty("list"))
      )
    ) {
      copyList({ ...listFeature, copy_list_id: list })
      if (isListItem) {
        backButtonHandler()
      }
    }
  }

  return (
    <>
      <Row>
        <Col xs={12}>Experience:</Col>
        <Col xs={12}>
          <Field
            name="experience"
            fullWidth={true}
            component={SingleSelectField}
            className="full-width"
            options={experiences.map(experience => ({
              value: experience.id,
              label: experience.name,
            }))}
            onChange={(event, newValue) => {
              resetSection(FORM_NAMES.LIST, "list_form.list")
              getExperiencesList({ event_id: newValue, all: true })
            }}
          />
        </Col>
      </Row>
      <Row className="my-4">
        <Col xs={12}>List:</Col>
        <Col xs={12}>
          <Field
            name="list"
            fullWidth={true}
            component={SingleSelectField}
            className="full-width"
            options={experiencesList.map(list => ({
              value: list.id,
              label: list.name,
            }))}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-end">
        <Col xl={2}>
          <SaveButton
            type="button"
            color="danger"
            fullWidth={true}
            onClick={closeHandler}
            content="Cancel"
          />
        </Col>
        <Col xl={2}>
          <SaveButton
            type="button"
            onClick={copyListHandler}
            content="Copy List"
            fullWidth={true}
          />
        </Col>
      </Row>
    </>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST)

const mapStateToProps = state => ({
  experiences: state.List.experiences,
  experiencesList: state.List.experiencesList,
  formSyncErrors: getFormSyncErrors(FORM_NAMES.LIST)(state),
  list: selector(state, "list_form.list"),
})

const mapDispatchToProps = dispatch => ({
  getExperiences: () => dispatch(getExperiences()),
  getExperiencesList: values => dispatch(getExperiencesList(values)),
  resetSection: (form, section) => dispatch(resetSection(form, section)),
  change: (field, value) => dispatch(change(FORM_NAMES.LIST, field, value)),
  copyList: values => dispatch(copyList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CopyListModal)
